module.exports = __webpack_public_path__ + "img/pix.c5f110e5.png";